'use strict';

/*
 * Sentry configuration
 *
 * The default sentry plugin sends any uncaught exception to Sentry.
 * This configuration also adds logged errors.  Try to avoid logging multiple lines for the same error,
 * since they will be considered separate events.
 */

customerZone.config(['$provide', 'errorCodeProvider', function($provide, errorCodeProvider){

    /* Add a decorator on $log.error
     *
     * This decorator will log everything to sentry.  If it's pure text, it gets logged
     * as a simple message with all arguments flattened to json.  If there's an Error in one of
     * the arguments, and exception will be logged instead, with the flattened representation
     * preceding as a breadcrumb.
     */
    $provide.decorator('$log', ['$delegate', 'Sentry', function($delegate, Sentry){
        var originalError = $delegate.error;
        $delegate.error = function(){

            if (!isServerError(arguments)) {
                // arguments is a special value that is iterable, but not an Array, so we can't invoke map directly on
                // it.
                var stringMessage = []
                    .map.call(arguments, function (argument) {
                        if (argument instanceof Error) return argument.message;
                        if (argument instanceof Object) return JSON.stringify(argument);
                        return ''+argument;
                    })
                    .join(' - ');
                var error = findError(arguments);
                if (error) {
                    Sentry.addBreadcrumb({
                        category: 'error',
                        message: stringMessage
                    });
                    Sentry.captureException(error);
                }
                else {
                    Sentry.captureException(new Error(stringMessage));
                }

            }
            return originalError.apply($delegate, arguments);
        };
        try {
            // angular mocks adds fields on the error function itself.  While this is non-standard ES5, it doesn't
            // break if __proto__ does not exist, and it does help the test context.
            $delegate.error.__proto__ = originalError;
        }
        catch (_){ /* could not set prototype. */ }
        return $delegate;
    }]);

    var findError = function(array){
        for (var i=0; i<array.length; i++){
            if (isError(array[i]))
                return array[i];
        }
        return undefined;
    };

    // Yanked from https://git.io/vS8DV re-used under CC0
    // with some tiny modifications
    var isError = function (value) {
        switch ({}.toString.call(value)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return value instanceof Error;
        }
    };

    var isServerError = function(errorArgs){
        if (errorArgs.length < 2) return false;
        var error = errorArgs[1];
        var errorCode = errorCodeProvider.$get();
        return errorCode.is(error, errorCode.HTTP_CONNECTION_ERROR) ||
            errorCode.is(error, errorCode.SENT_TO_LOGIN) ||
            errorCode.is(error, errorCode.SERVER_ERROR) ||
            errorCode.is(error, errorCode.POLL_TIMEOUT) ||
            errorCode.is(error, errorCode.POLL_CANCELLED) ||
            errorCode.is(error, errorCode.REQUEST_THROTTLED);
    };
}])

.run(['$rootScope', '$log', 'Sentry', 'Session', function($rootScope, $log, Sentry, Session){

    /**
     * Set the Sentry UserContext depending on the given profile
     */
    var contextFromProfile = function(event, profile){
        if (profile && profile.id){
            Sentry.setUser(profile);
        }
        else {
            Sentry.setUser();
        }
    };

    contextFromProfile(undefined, Session.profile());
    $rootScope.$on(Session.PROFILE_CHANGED_EVENT, contextFromProfile);

    Sentry.setExtra({impersonating: !!Session.impersonating()});
    $rootScope.$on(Session.FLAGS_CHANGED_EVENT, function(){
        Sentry.setExtra({impersonating: !!Session.impersonating()});
    });

    $rootScope.$on('$routeChangeStart', function(event, toRoute){
        Sentry.setTags({route: toRoute.originalPath});
    });

    $rootScope.$on('$routeChangeSuccess', function(event, toRoute, fromRoute){
        Sentry.addBreadcrumb({
            category: '$route',
            message: 'routed from ' + (fromRoute ? fromRoute.originalPath : '-') +' to '+toRoute.originalPath
        });
    });

}])

.factory('SentryLoggingInterceptor', ['$injector', '$log', 'Sentry', function ($injector, $log, Sentry) {
    // We have to inject by hand here to avoid circular dependencies

    /**
     * Remove values from payload that sentry considers sensitive.  This will prevent sentry from throwing
     * away half of our information.
     */
    var scrub = function(payload){
        payload = JSON.parse(JSON.stringify(payload)); //naive deep-copy
        if ('password' in payload){
            payload.password = '***';
        }
        if ('refresh_token' in payload){
            payload['refresh_token'] = '***';
        }
        if ('Authorization' in payload){
            payload.Authorization = '***';
        }
        return payload;
    };

    var logRequest = function(response) {
        try {
            var request = response.config;
            var message = request.method+' '+request.url+' ['+response.status+']';
            var bcRequest;
            var bcResponse= JSON.stringify({
                'status': response.status,
                'headers': response.headers(),
                'data': response.data
            }, undefined, 2);

            if (request.data){
                bcRequest = JSON.stringify({
                    headers: scrub(request.headers),
                    data: scrub(request.data)
                }, undefined, 2)
                    .replace(/password/g, '__pwd__')
                    .replace(/refresh_token/g, '__ref_tkn__')
                    .replace(/Authorization/gi, '__auth__');
            }
            else {
                bcRequest = JSON.stringify({
                    headers: scrub(request.headers)
                }, undefined, 2)
                    .replace(/password/g, '__pwd__')
                    .replace(/refresh_token/g, '__ref_tkn__')
                    .replace(/Authorization/gi, '__auth__');
            }

            Sentry.addBreadcrumb({
                category: '$http',
                message: message,
                data: {
                    request: bcRequest,
                    response: bcResponse
                }
            });
        }
        catch (error){
            $log.error('Error reporting $http breadcrumb', error);
        }
        return response;
    };

    var SentryInterceptor = {
        response: logRequest,
        responseError: function(request){ throw logRequest(request); }
    };

    return SentryInterceptor;
}])


.config(['$httpProvider', function($httpProvider){
    $httpProvider.interceptors.push('SentryLoggingInterceptor');
}]);

